module.exports = __webpack_public_path__ + "media/images/flags/4x3/alb-e955cd23348edcdeccc1e70d75a023bb.svg";